import React from "react";
import { isEmpty } from "lodash";

import { FieldChangesType } from "types";

import styles from "../pend.module.scss";

const fieldsDictionary = {
	MerchantId: "Merchant",
	AddressVerification: "Address Verification",
	BusinessLicence: "Business Licence",
	DriversLicence: "Drivers Licence",
	MissingDocumentation: "Missing Documentation",
	IllegibleDocumentation: "Illegible Documentation",
	MissingSignatures: "MissingSignatures",
	PricingIssues: "PricingIssues",
	VoidedCheck: "VoidedCheck",
	ResponseSubmitted: "Response Submitted",
};

type HistoryFieldChangesProps = {
	fieldChanges: Array<FieldChangesType>;
};

const HistoryFieldChanges = ({ fieldChanges }: HistoryFieldChangesProps) => {
	const correctNaming = name => {
		if (name in fieldsDictionary) {
			name = fieldsDictionary[name];
		}
		return name;
	};

	return (
		<ul className={`${styles.historyFieldsList} list-unstyled`}>
			{fieldChanges.map((item, index) => {
				const { fieldName, fromValue, toValue } = item;
				return (
					<li key={index} className="break-word">
						{isEmpty(fieldName) && isEmpty(fromValue) ? (
							"Created"
						) : (
							<>
								{isEmpty(toValue) ? (
									<>
										Removed
										<span className="text-danger">
											&nbsp;<i>{fromValue}</i>
										</span>
										&nbsp;from
										<span className="text-primary">
											&nbsp;
											<b>{correctNaming(fieldName)}</b>
											&nbsp;
										</span>
									</>
								) : (
									<>
										{fieldName === "Response"
											? "Created"
											: "Changed"}
										<span className="text-primary">
											&nbsp;
											<b>{correctNaming(fieldName)}</b>
											&nbsp;
										</span>
										{isEmpty(fromValue) ? (
											""
										) : (
											<span>
												from{" "}
												<i>
													{correctNaming(fromValue)}
												</i>
											</span>
										)}
										{fieldName !== "Response" && " to"}
										<span className="text-primary">
											&nbsp;
											<b>{correctNaming(toValue)}</b>
											&nbsp;
										</span>
									</>
								)}
							</>
						)}
					</li>
				);
			})}
		</ul>
	);
};

export default HistoryFieldChanges;
